import React from 'react';
import PropTypes from 'prop-types';
import { Box, Copy, Icon, IconWrapper, Optional } from '@honda-canada/design-system-react';
import themeStyles from './ContentDetails.style';

const Container = themeStyles.apply(Box, 'Container');
const TitleContainer = themeStyles.apply(Box, 'TitleContainer');
const TitleContent = themeStyles.apply(Copy, 'TitleContent');
const SubTitleContent = themeStyles.apply(Copy, 'SubTitleContent');

const ContentDetails = ({ iconName, title, subTitle, testId, isTitleBold }) => {
  if (!iconName || !title) return null;

  return (
    <Container alignToStart={isTitleBold} data-testid={testId}>
      <IconWrapper size="iconWrapper.xss">
        <Icon name={iconName} />
      </IconWrapper>
      <TitleContainer>
        <TitleContent isTitleBold={isTitleBold} data-testid="cy-title">
          {title}
        </TitleContent>
        <Optional when={subTitle}>
          <SubTitleContent data-testid="cy-subTitle">{subTitle}</SubTitleContent>
        </Optional>
      </TitleContainer>
    </Container>
  );
};

ContentDetails.defaultProps = {
  isTitleBold: false,
};

ContentDetails.propTypes = {
  iconName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isTitleBold: PropTypes.bool,
  subTitle: PropTypes.string,
  testId: PropTypes.string,
};

export default ContentDetails;
